<template>
  <default-layout>
    <b-container class="pt-5 pb-3">
      <div class="text-center mb-5">
        <h1>Frequently Asked Questions</h1>
        <hr>
      </div>

      <div class="mb-5">
        <div class="text-center mb-3">
          <h3>Buying on ZoopLocal</h3>
          <em>You can furnish your home without leaving your home!</em>
        </div>

        <collapse-list-item
          title="How does it work?">
          Our catalogue features a collection of quality home furnishings
          from a variety of sources in your local area. Browsing our
          selection online makes it convenient for you to:
          <ol class="mt-2">
            <li>search</li>
            <li>select</li>
            <li>purchase what you want, when you want it</li>
          </ol>
        </collapse-list-item>

        <collapse-list-item
          title="How do I get started?">
          Simply <router-link to="/listings">browse our catalogue</router-link>
          to search what's available in your area! Once you find an item you love,
          click on the product to explore the listing details such as item
          description, pricing, and delivery options.
        </collapse-list-item>

        <collapse-list-item
          title="How do purchases work on ZoopLocal?">
          Once you are ready to purchase an item, click "Buy on Zoop." This will
          take you to our checkout page. Please note that all customers are
          required to register with ZoopLocal before making a purchase. If you
          have not done so, you can
          <router-link to="/authentication/register">set up your personal account</router-link>
          here.
          <br>
          <br>
          To proceed with your purchase:
          <ol>
            <li>Double-check the listing details for the item's condition and the seller's delivery
            preferences.</li>
            <li>When you are ready to officially place your order, select "Submit."</li>
            <li>
              You will receive a "Purchase Request Submitted" alert
              that confirms your request.
            </li>
            <li>
              A notification will be sent to the seller,
              who will have 24 hours to confirm the purchase.
            </li>
            <li>
              Once the seller confirms your order, you will receive a
              message from ZoopLocal confirming the sale.
            </li>
            <li>
              Using the ZoopLocal Messaging portal in the right-hand
              corner of the menu bar, buyers can connect to their
              sellers to determine their own forms of payment and delivery.
            </li>
            <ul>
              <li>
                Do not select "Mark as Delivered" until the item
                and payments have been exchanged.
              </li>
              <li>
                ZoopLocal is not responsible for delivery or inspection of the product at the time
                of delivery. ZoopLocal strongly recommends documenting/photographing the item at
                the time of delivery.
              </li>
            </ul>
          </ol>
        </collapse-list-item>

        <collapse-list-item
          title="What happens after my purchase is confirmed?">
          After your order is placed and confirmed, ZoopLocal will connect
          you to the seller through our secure Messaging portal (upper-right corner
          of the menu bar) to arrange payment and delivery details.
          ZoopLocal recommends payment methods such as Venmo and PayPal.
          ZoopLocal's Messaging portal is accessible at any time by
          simply selecting the <router-link to="/account/purchases">Messages</router-link>
          tab located in the right-hand corner of the menu bar.
          Upon receiving new messages, you will be alerted in the same
          <router-link to="/account/purchases">Messages</router-link> tab.
          To ensure privacy, we do not provide buyer and seller contact information.
          Please inpect the product upon delivery; ZoopLocal has a strict no-refund policy.
        </collapse-list-item>

        <collapse-list-item
          title="How are items delivered?">
          <ol>
            <li>The seller can arrange for delivery</li>
            <li>The seller can meet buyer at a designated location</li>
            <li>
              The buyer is responsible for setting up the delivery,
              which must be in line with the seller's preferences as
              specified in the item's listing.
            </li>
          </ol>
          <br>
          As ZoopLocal is not involved in payment or delivery, both buyer
          and seller parties are responsible for a successful arrangement.
          <br>
          <br>
          The seller will select "Mark as Delivered" only after exchange
          of the product and payment are received by each party.
        </collapse-list-item>

        <collapse-list-item
          title="How much does delivery cost?">
          Delivery is to be communication between the buyer and
          seller&mdash;items can be arranged to be exchanged locally or
          if the buyer chooses to have an item delivered, the buyer is
          responsible for the arrangements and subsequent fees. Below is
          a list of suggestions for delivery services. Please note each delivery
          service operates as an independent business and is not associated with
          ZoopLocal. As a result, the pricing and scheduling structure may
          vary.
        </collapse-list-item>

        <collapse-list-item
          title="Where do I go if I have questions or need assistance?">
          ZoopLocal Customer Service is available Monday through Friday,
          10:00am - 4:00 pm CST. Please contact us via email or
          phone, and we will be happy to assist you.
          <br>
          <br>
          Email: support@zooplocal.com<br>
          Phone: 1-866-899-9667
        </collapse-list-item>
      </div>

      <div>

        <div class="text-center mb-3">
          <h3>Selling on ZoopLocal</h3>
          <em>Why pay to store it, ship it, move it or lose it when you can Zoop it!</em>
        </div>

        <collapse-list-item
          title="What does it cost to sell on Zoop?">
          All customers are required to register with ZoopLocal before
          selling on the platform. If you have not done so, you can
          <router-link to="/authentication/register">set up your personal account</router-link>

          ZoopLocal charges a $30 listing fee for each item. This covers the
          cost for the online space to connect you with the largest audience
          of serious buyers.
          <br>
          <br>
          Please note, all listings must be approved by ZoopLocal before
          they are live on our site. Your credit card will not be charged
          for the fee until your listing is approved where the listing fee
          is good for 60 days. Upon the expiration date, you can choose to
          renew your listing for another 60 days or remove your item.
        </collapse-list-item>

        <collapse-list-item
          title="Does ZoopLocal sell or share my data?">
          Never! ZoopLocal's listing fee helps pay for the expenses
          instead of selling your data online.
        </collapse-list-item>

        <collapse-list-item
          title="How do I create a listing?">
          Listing an item for sale is easy!

          All customers are required to register with ZoopLocal before
          selling on the platform. If you have not done so, you can
          <router-link to="/authentication/register">set up your personal account
            here</router-link>.
          <br><br>
          Simply click "Start Selling"
          on the homepage or log in to your account to create a new listing.
          Please refer to our tips and tricks below to create your quality listing.
        </collapse-list-item>

        <collapse-list-item
          title="Why does my listing have to be approved?">
          ZoopLocal selects items of good quality in good condition that
          are suitable to our “local” market. As a result, what we feature
          goes quickly. Because ZoopLocal is not responsible for delivery, the
          buyer must assure the product's quality matches the description
          on the ZoopLocal site upon exchange. ZoopLocal strongly strongly
          suggests documenting/photographing the item at delivery time. Once
          the item is delivered and accepted, ZoopLocal has a strict
          no-refund policy.
        </collapse-list-item>

        <collapse-list-item
          title="What details are required for my listing?">
          The listing process requires information such as the listing
          category, price, description, item colors and materials, and
          images. All imperfections must be shown in the images.
          ZoopLocal's listing process is pain-free for the seller
          and provides potential buyers with the best possible information
          on your items.
        </collapse-list-item>

        <collapse-list-item
          title="What happens after my item has sold?">
          Congratulations! After your item sells, you will receive a
          notification from ZoopLocal requiring you to confirm the sale
          within 24 hours. If sale is not confirmed in 24 hours, the sale
          is cancelled. Once the sale is confirmed, ZoopLocal will connect
          you with the buyer through the ZoopLocal Messaging portal in the
          right-hand corner of the menu bar to arrange delivery. The seller
          does not enter "Mark as Delivered" on ZoopLocal until the item and
          payment have been completed. ZoopLocal has a no-refund policy.
          To ensure privacy, we do not provide buyer and seller contact
          information.
          <br><br>
          It is up to the buyer and seller to arrange a time and location
          that is convenient for both parties to schedule deliveries. As
          outlined in ZoopLocal's
          <router-link to="terms">Terms and Conditions</router-link>, all
          sales are final once confirmed by the seller and items will be
          removed from the catalogue once the buyer submits the request for
          purchase. The seller will be held responsible if they fail to
          follow through with the item's delivery.
        </collapse-list-item>

        <collapse-list-item
          title="What happens if my purchase is cancelled?">
          While ZoopLocal provides our customers the platform to buy and
          sell home furnishings, it is up to the sellers to complete their
          transactions. If your seller fails to complete your transaction,
          please contact ZoopLocal Support. Sellers who fail to complete
          their transactions will no longer be qualified to list on ZoopLocal.
        </collapse-list-item>

        <collapse-list-item
          title="When do I get paid?">
          After a sale is confirmed, ZoopLocal will connect the buyer and
          seller through our Messaging portal in the right-hand corner of
          the menu bar to exchange funds. From there, ZoopLocal recommends
          buyers to pay via Venmo or PayPal at the time of delivery. When
          meeting in person, ZoopLocal does not encourage customers to accept
          checks or cash. For more information, refer to our
          <strong>How do purchases work on ZoopLocal?</strong> section from
          "Buying and Selling on ZoopLocal" above.
        </collapse-list-item>

        <collapse-list-item
          title="Can I delete a listing?">
          Yes, it is especially important to delete any of your items that
          are no longer available for sale. To do so, sign-in to your account
          and select <router-link to="/account/listings">Listings</router-link>
          Next, choose the item you wish to remove. Click <strong>Edit Listing</strong>
          and then <strong>Remove Listing</strong>. This will trigger confirmation that
          the listing is removed and prevent future buyers from purchasing an item that
          is no longer available. Such confirmations will come via message portal, email,
          and/or text message.
        </collapse-list-item>
      </div>
    </b-container>
  </default-layout>
</template>

<script>
import CollapseListItem from '@/components/faq/CollapseListItem.vue'

export default {
  name: 'FAQ',
  components: {
    CollapseListItem,
  },
}
</script>
